import { Component, Renderer } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { ViewController } from 'ionic-angular/navigation/view-controller';
import { ToastProvider } from '../../providers/toast/toast';
import { SurveyPage } from '../survey/survey';
import { TranslateService } from '@ngx-translate/core';

@IonicPage()
@Component({
  selector: 'page-survey-modal',
  templateUrl: 'survey-modal.html',
})
export class SurveyModalPage {

  item = {};
  id: number;
  message = "";
  title = "";

  constructor(
    public navCtrl: NavController,
     public navParams: NavParams,
     private viewCtrl: ViewController,
     private translate: TranslateService,
     private toast: ToastProvider,
     private renderer: Renderer) {
      console.log('UserId', navParams.get('id'), navParams.get('message'));
      this.id = navParams.get('id');
      this.message = navParams.get('message');
      this.title = navParams.get('title');
      this.renderer.setElementClass(viewCtrl.pageRef().nativeElement, 'popup', true);     
  }

  onGoTo(){
    if(this.title== "survey"){
        this.navCtrl.push(SurveyPage);
        this.dismiss();
    }
  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad SurveyModalPage');
  }

  dismiss(){
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/survey-modal/survey-modal.ts